import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGO_URL } from "@/lib/api";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="forgot-page" className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md bg-white border border-scu-smoke/15 rounded-md p-8">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} className="h-12" alt="SCU" />
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-scu-purple font-bold">Parent Account</div>
            <div className="font-bebas text-3xl tracking-wide text-scu-obsidian leading-none">Forgot Password</div>
          </div>
        </div>
        {sent ? (
          <div className="mt-6 p-4 border border-emerald-300 bg-emerald-50 rounded-md text-sm text-emerald-900" data-testid="forgot-sent">
            If an account exists for that email, a password reset link has been sent. The link expires in 1 hour.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-widest text-scu-smoke font-bold">Email</Label>
              <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full h-11 bg-scu-purple hover:bg-scu-electric text-white font-bold uppercase tracking-widest">
              {loading ? "Sending…" : "Send Reset Link"}
            </Button>
          </form>
        )}
        <div className="mt-6 text-sm text-center text-scu-smoke">
          <Link to="/login" data-testid="forgot-back-login" className="text-scu-purple hover:text-scu-electric font-bold">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
